<template>
  <q-card
    class="card q-mx-auto"
    style="
      max-width: 1280px;
      width: 100%;
      height: 650px !important;
      max-height: 90vh !important;
    "
  >
    <div class="row justify-between">
      <div>
        <q-tabs v-model="tab" inline-label>
          <q-tab
            v-for="(tab, i) in tabs"
            v-if="!tab.disable"
            no-caps
            :name="tab.name"
            :key="i"
            :disable="tab.disable"
          >
            <div class="row items-center text-accent">
              <q-icon :name="tab.icon" size="xs"> </q-icon>
              <span class="tabTitle q-ml-sm"> {{ tab.label }}</span>
            </div>
          </q-tab>
        </q-tabs>
      </div>
      <div class="row items-center">
        <q-btn
          color="primary"
          no-caps
          style="height: 33px"
          v-if="!data.solutionsBusiness_id"
          @click="adoptSolution"
        >
          <span class="buttonText"> Adopt Solution </span>
        </q-btn>
        <q-btn icon="mdi-close" flat round @click="closeDialog" class="q-mr-sm">
        </q-btn>
      </div>
    </div>
    <div class="row">
      <q-tab-panels v-model="tab" animated class="full-width" style="height: 600px">
        <q-tab-panel name="info" class="q-pa-none">
          <div class="row full-width" style="height: 30%">
            <div
              class="row bg-accent items-center col-auto"
              style="height: 100%; width: 50%"
            >
              <span class="headerTitle text-white q-ml-xl">
                {{ data.title }}
              </span>
            </div>
            <div class="col" style="height: 100%;">
              <q-img
                v-if="data.imageUrl"
                style="width: 100%; height: 100%"
                :src="data.imageUrl"
              >
              </q-img>
              <div
                v-else
                class="bg-grey"
                style="width: 100%; height: 149px"
              ></div>
            </div>
          </div>
          <div class="row" style="height: 70%">
            <div style="width: 50%" class="q-px-xl q-pt-xl col-auto">
              <div class="description q-mb-md">
                {{ data.description }}
              </div>
              <div class="subHeader q-mb-md">How will this help me?</div>
              <div class="description q-mb-md">
                {{ data.help }}
              </div>
              <div class="subHeader q-mb-md" v-if="data.solutionsBusiness_id">
                Add your own notes to this solution
              </div>
              <div>
                <q-input
                  type="textarea"
                  v-model="formData.notes"
                  v-if="data.solutionsBusiness_id"
                  @blur="saveSolution"
                  filled
                  rows="3"
                ></q-input>
              </div>
            </div>
            <div class="outcomeSection col">
              <div class="row q-pa-lg">
                <div>
                  <div class="row q-mt-md">
                    <span class="title">Level of Impact </span>
                  </div>
                  <div
                    class="row q-my-sm"
                    v-for="(outcome, i) in data.outcomes"
                    :key="i"
                  >
                    <div class="row">
                      <img
                        :src="getOutcomeImage(outcome)"
                        class="q-mr-sm"
                        style="width: 23px; height: 23px"
                      />
                      <img
                        class="q-mr-sm"
                        :src="getOutcomeImage(outcome)"
                        style="width: 23px; height: 23px"
                        :style="`opacity:${
                          outcome.impact == 'Low' ? '0.5' : '1'
                        }`"
                      />
                      <img
                        :src="getOutcomeImage(outcome)"
                        style="width: 23px; height: 23px"
                        :style="`opacity:${
                          outcome.impact != 'High' ? '0.5' : '1'
                        }`"
                      />
                    </div>
                  </div>
                  <div class="q-mt-xl">
                    <div class="row">
                      <span class="title">Cost </span>
                    </div>

                    <div class="row">
                      <img
                        src="/statics/money-icon.svg"
                        class="q-mr-sm"
                        style="width: 23px; height: 23px"
                      />
                      <img
                        class="q-mr-sm"
                        src="/statics/money-icon.svg"
                        style="width: 23px; height: 23px"
                        :style="`opacity:${data.cost == 'Low' ? '0.5' : '1'}`"
                      />
                      <img
                        src="/statics/money-icon.svg"
                        style="width: 23px; height: 23px"
                        :style="`opacity:${data.cost != 'High' ? '0.5' : '1'}`"
                      />
                    </div>
                  </div>
                  <div class="q-mt-lg">
                    <div class="row">
                      <span class="title"> Difficulty </span>
                    </div>
                    <div class="row">
                      <img
                        src="/statics/work-icon.svg"
                        class="q-mr-sm"
                        style="width: 23px; height: 23px"
                      />
                      <img
                        class="q-mr-sm"
                        src="/statics/work-icon.svg"
                        style="width: 23px; height: 23px"
                        :style="`opacity:${data.ease == 'Low' ? '0.5' : '1'}`"
                      />
                      <img
                        src="/statics/work-icon.svg"
                        style="width: 23px; height: 23px"
                        :style="` opacity:${data.ease != 'High' ? '0.5' : '1'}`"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </q-tab-panel>
        <q-tab-panel name="actions" class="q-pa-none">
          <q-scroll-area
            :thumb-style="{
              background: '#162c479c',
              opacity: 1,
              width: '8px',
              height: '8px',
              borderRadius: '20px',
            }"
            style="width: 100%; height: 100%; min-height: 493px"
          >
            <div class="row full-width">
              <div class="col">
                <div
                  class="row items-center bg-accent"
                  style="width: 100; height: 73px"
                >
                  <div class="full-width">
                    <span class="text-white actionHeaderTitle q-ml-lg">
                      Actions related to this solution
                    </span>
                  </div>
                </div>
                <div>
                  <q-scroll-area
                    :thumb-style="{
                      background: '#162c479c',
                      opacity: 1,
                      width: '8px',
                      height: '8px',
                      borderRadius: '20px',
                    }"
                    style="height: 420px"
                    v-if="!actionScreen"
                  >
                    <div class="row items-center q-pa-md">
                      <q-card flat class="q-pa-md col-12 actionsCardTitle">
                        {{ data.title }}
                      </q-card>
                    </div>

                    <div
                      class="row items-center q-px-lg q-py-sm"
                      v-for="(action, i) in actionsList"
                      :key="i"
                    >
                      <q-card flat class="q-pa-md col-12 actionsCardTitle">
                        <span> Action {{ i + 1 }} </span> <br />
                        <span class="actionDescription">
                          {{ action.value }}
                        </span>
                      </q-card>
                    </div>
                  </q-scroll-area>
                </div>
              </div>
            </div>
          </q-scroll-area>
        </q-tab-panel>
        <!--FIND TAB-->
        <q-tab-panel name="find" class="q-pa-none" style="overflow: hidden; height: 100%">
          <div>
            <div
              class="row bg-accent items-center q-pl-md"
              style="height: 71px"
            >
              <span class="headerTitle text-white">
                Suppliers that can help you with this solution:
              </span>
            </div>
            <div class="searchOnlineSection">
              <div class="row q-pt-lg q-pb-md q-px-md">
                <span class="searchOnlineSection__title"> Search Online </span>
              </div>
              <div
                class="row justify-between"
                style="padding-left: 50px; padding-right: 50px"
              >
                <div>
                  <div class="row q-pb-md">
                    <span class="searchOnlineSection__subtitle">
                      By clicking this button, we will automatically perform a
                      internet search for:
                    </span>
                  </div>
                  <div class="row">
                    <span class="searchOnlineSection__subtitle text-bold">
                      " {{ data.title }} "
                    </span>
                  </div>
                </div>
                <div>
                  <q-btn
                    color="primary"
                    unelevated
                    no-caps
                    @click="googleSearch(data.title)"
                  >
                    <span class="searchOnlineSection__btnText text-white">
                      Click to Search
                    </span>
                  </q-btn>
                </div>
              </div>
            </div>
            <div class="row q-mt-lg" v-if="featuredListing">
              <div>
                <div class="row q-pt-lg q-pb-md q-px-md">
                  <span class="searchOnlineSection__title"> We Recommend </span>
                </div>
                <div class="row" style="margin-right: 30px; margin-left: 50px">
                  <div
                    class="featuredListing__supplierName"
                    style="margin-right: 140px"
                  >
                    {{ featuredListing.supplierName }}
                  </div>
                  <div
                    class="featuredListing__supplierName"
                    style="margin-right: 120px"
                  >
                    Benefits of using this supplier
                  </div>
                  <div class="featuredListing__supplierName">Key Outcomes</div>
                </div>
              </div>
              <div class="row" style="margin-right: 50px; margin-left: 50px">
                <!--FEATURED LISTING INFO COLUMN-->
                <div style="width: 200px; margin-right: 30px">
                  <div class="row q-mt-lg">
                    <q-img
                      class="q-mx-auto"
                      :src="featuredListing.imageUrl"
                      style="width: 200px"
                    >
                    </q-img>
                  </div>
                  <div class="row q-mt-md">
                    <div class="featuredListing__supplierName">About</div>
                  </div>
                  <div class="row q-mb-sm">
                    <span class="featuredListing__about">
                      {{ featuredListing.about }}
                    </span>
                  </div>
                </div>
                <!--FEATURED LISTING BENEFITS COLUMN-->
                <div style="width: 300px; margin-right: 40px">
                  <q-item
                    v-for="(benefit, i) in featuredListingBenefitsList"
                    :key="i"
                    style="height: 59px"
                  >
                    <q-item-section top avatar class="q-px-none">
                      <q-icon
                        name="mdi-check-circle"
                        class="q-mx-auto"
                        color="grey"
                      >
                      </q-icon>
                    </q-item-section>
                    <q-item-section>
                      <q-item-label lines="3" class="featuredListing__benefits">
                        {{ benefit.description }}
                      </q-item-label>
                    </q-item-section>
                  </q-item>
                </div>
                <!--FEATURED LISTIN KEY OUTCOMES COLUMN-->
                <div>
                  <div
                    class="row q-mt-sm"
                    style="margin-bottom: 15px"
                    v-for="(benefit, i) in featuredListingBenefitsList"
                    :key="i"
                  >
                    <q-img
                      v-if="!benefit.customOutcomeTitle"
                      :src="getOutcomeImage(benefit)"
                      style="width: 40px; height: 40px"
                    >
                    </q-img>
                    <q-img
                      v-else
                      :src="benefit.customOutcomeImageUrl"
                      style="width: 40px; height: 40px"
                    >
                    </q-img>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="row justify-between"
              style="margin-left: 50px; margin-right: 50px"
              v-if="featuredListing"
            >
              <div>
                <div class="row q-mb-sm">
                  <div class="featuredListing__supplierName">Service Area</div>
                </div>
                <div class="row">
                  <span class="featuredListing__about">
                    {{ featuredListing.serviceArea }}
                  </span>
                </div>
              </div>
              <div>
                <sustainability-button
                  v-if="featuredListing.url"
                  class="bg-primary"
                  borderRadius="3px"
                  @click="learnMore(featuredListing.url)"
                >
                  <div class="row justify-center items-center full-height">
                    <div class="buttonText text-white">Click to Find</div>
                  </div>
                </sustainability-button>
              </div>
            </div>
          </div>
          <!--OTHER SUPPLIERS SECTION-->
          <div
            :class="`otherSuppliersSection ${featuredListing ? 'q-mt-xl' : ''}`"
          >
            <div class="row q-pt-lg q-pb-md q-px-md justify-between">
              <div>
                <span class="searchOnlineSection__title">
                  Other Suppliers
                </span>
              </div>
              <div>
                <sustainability-button
                  class="bg-accent"
                  width="108px"
                  height="26px"
                  borderRadius="3px"
                  @click="supplierForm = !supplierForm"
                >
                  <div class="row justify-center items-center full-height">
                    <div class="buttonText text-white">
                      {{ supplierForm ? "Go Back" : "Suggest a Supplier" }}
                    </div>
                  </div>
                </sustainability-button>
              </div>
            </div>
            <div v-if="!supplierForm">
              <div v-if="findEntries.length > 0">
                <div class="row q-mt-xs q-px-lg">
                  <span
                    class="text-accent findColumnHeader"
                    style="margin-left: 20px; margin-right: 90px"
                  >
                    Product / Service Description
                  </span>
                  <span
                    class="text-accent findColumnHeader"
                    style="margin-right: 50px"
                  >
                    Supplier Name
                  </span>
                  <span
                    class="text-accent findColumnHeader"
                    style="margin-right: 20px"
                  >
                    Service Area
                  </span>
                  <span
                    class="text-accent findColumnHeader"
                    style="margin-right: 25px"
                  >
                    Find Here
                  </span>
                  <span class="text-accent findColumnHeader"> Feedback </span>
                </div>
                <div class="q-mt-md">
                  <div
                    class="row q-mt-sm"
                    style="margin-left: 45px"
                    v-for="(findEntry, i) in findEntries"
                    :key="i"
                  >
                    <div class="row items-center justify-center q-mb-sm">
                      <span
                        class="findEntryText"
                        style="margin-right: 152px; width: 120px"
                      >
                        {{ findEntry.productService }}
                      </span>
                      <span
                        class="findEntryText"
                        style="margin-right: 43px; width: 100px"
                      >
                        {{ findEntry.supplierName }}
                      </span>
                      <span class="findEntryText" style="width: 100px">
                        {{ findEntry.serviceArea }}
                      </span>
                      <div
                        class="row items-center"
                        style="margin-right: 8px; width: 80px"
                      >
                        <sustainability-button
                          v-if="findEntry.url"
                          class="bg-primary"
                          borderRadius="3px"
                          @click="learnMore(findEntry.url)"
                        >
                          <div
                            class="row justify-center items-center full-height"
                          >
                            <div class="buttonText text-white">
                              Click to Find
                            </div>
                          </div>
                        </sustainability-button>
                        <!-- <div v-else style="width: 77px; height: 26px"></div> -->
                      </div>
                      <div class="row items-center">
                        <q-icon
                          @click="likeFindEntry(true, findEntry)"
                          class="cursor-pointer"
                          :name="likeStatus(true, findEntry)"
                          color="accent"
                        >
                        </q-icon>
                        <span class="dislikeText q-ml-xs">
                          {{ findEntry.likesDislikesData.likes }}
                        </span>
                        <q-icon
                          @click="likeFindEntry(false, findEntry)"
                          :name="likeStatus(false, findEntry)"
                          color="accent"
                          class="q-ml-xs cursor-pointer"
                        >
                        </q-icon>
                        <span class="dislikeText q-ml-xs"> Dislike </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="row items-center justify-center">
                  <div style="width: 318px; text-align: center">
                    <p class="otherSuppliersSection_emptyText">
                      We have no Suppliers listed for this solution card at this
                      time, check back later or suggest a company
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="row">
                <supplier-suggestion-form
                  @close="supplierForm = false"
                ></supplier-suggestion-form>
              </div>
            </div>
          </div>
        </q-tab-panel>
        <!---Story Card PANEL-->
        <q-tab-panel name="storyCard" class="q-pa-none">
          <!-- Temporarily disabling the 'Your stories for this solution view' as the API endpoint is returning completely
           invalid results, see `&& false` below-->
          <div
            v-if="storyCards.length > 0 && !newStoryCard && false"
            class="column bg-grey-3"
            style="height: 100%"
          >
            <div class="col">
              <q-scroll-area
                :thumb-style="{
                  background: '#162c479c',
                  opacity: 1,
                  width: '8px',
                  height: '8px',
                  borderRadius: '20px',
                }"
                style="width: 100%; height: 100%"
              >
                <div class="row q-pa-lg q-px-xl q-col-gutter-y-md">
                  <div class="col-12 text-accent2">
                    <b>Your Stories for this solution</b>
                  </div>
                  <div
                    class="col-6"
                    v-for="(sc, index) in storyCards"
                    :key="`scIndex_${index}`"
                  >
                    <StoryCard style="margin: auto" :data="sc"></StoryCard>
                  </div>
                </div>
              </q-scroll-area>
            </div>
            <div class="q-px-xl q-py-md">
              <q-btn
                label="Create a Story"
                flat
                class="bg-accent text-white"
                no-caps
                @click="newStoryCard = true"
              ></q-btn>
            </div>
          </div>
          <div v-else>
            <StoryCardForm
              :hide-header="true"
              :close-function="saveStoryCardFunction"
              :from-solution-card="true"
              :solutions="[{ id: data.id}]"
              :default-data="data"
            >
            </StoryCardForm>
          </div>
        </q-tab-panel>
      </q-tab-panels>
    </div>
    <q-dialog v-model="feedbackDialog" persistent>
      <q-card style="width: 500px" class="feedbackDialogCard">
        <q-card-section>
          <div class="row justify-between">
            <div>
              <span class="feedbackDialogCard__title"> Feedback </span>
            </div>
            <q-btn
              icon="mdi-close"
              flat
              rounded
              @click="feedbackDialog = !feedbackDialog"
            >
            </q-btn>
          </div>
          <dislike-feedback-form @close="feedbackDialog = !feedbackDialog">
          </dislike-feedback-form>
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-card>
</template>

<script>
import { mapGetters } from "vuex";
import { getOutcomeImage } from "@/functions/getOutcomeImage";
import SustainabilityButton from "@/components/sustainabilityButton/sustainabilityButton.vue";
import SupplierSuggestionForm from "@/components/supplierSuggestionForm/supplierSuggestionForm.vue";
import DislikeFeedbackForm from "@/components/dislikeFeedbackForm/dislikeFeedbackForm.vue";
import moment from "moment";
import StoryCardForm from "@/components/storyCards/storyCardForm";
import StoryCard from "@/components/storyCards/storyCard.vue";
export default {
  components: {
    SustainabilityButton,
    SupplierSuggestionForm,
    DislikeFeedbackForm,
    StoryCardForm,
    StoryCard,
  },
  computed: {
    ...mapGetters({
      data: "solutions/business/selectedSolution",
      actionsList: "solutions/business/actions/list",
      findEntries: "solutions/findEntries/list",
      currentUserData: "auth/currentUserData",
      selectedAction: "actions/selectedAction",
      featuredListingList: "solutions/findEntries/featuredListings/list",
      featuredListingBenefitsList:
        "solutions/findEntries/featuredEntriesBenefits/list",
      storyCards: "storyCard/list",
      storyCardsLoading: "storyCard/listLoading",
    }),
    featuredListing() {
      if (this.featuredListingList.length > 0) {
        return this.featuredListingList[0];
      } else {
        return null;
      }
    },
    tabs() {
      return [
        {
          name: "info",
          label: "Info",
          icon: "fas fa-lightbulb",
          disable: false,
        },
        {
          name: "actions",
          label: "Actions",
          icon: "mdi-wrench",
          disable: true,
        },
        {
          name: "find",
          label: "Find",
          icon: "mdi-file-document-box",
          disable: this.data && this.data.hideFindTab ? true : false,
        },
        {
          name: "storyCard", //STORY
          label: "Story Card",
          icon: "mdi-file-document-box",
          disable: true,
        },
      ];
    },
  },
  mounted() {
    this.init();
    this.storyFormData["date"] = moment(Date.now()).format("YYYY/MM/DD");
    this.handleRoute();
  },
  watch: {
    $route: {
      handler() {
        this.handleRoute();
      },
      deep: true,
    },
  },
  data: () => ({
    supplierForm: false,
    formData: {
      notes: "",
    },
    storyFormData: {
      title: "",
      date: "",
      description: "",
    },
    filteredFindEntry: [],
    tab: "info",

    actionScreen: false,
    //dislikeFeedbackDialog
    feedbackDialog: false,

    newStoryCard: false,
  }),
  methods: {
    googleSearch(title) {
      let searchTitle = title.replace(/\s/g, "+");
      window.open(`https://www.google.com/search?q=${searchTitle}`, "_blank");
    },
    async likeFindEntry(isLikeThumb, findEntry) {
      let status = null;
      if (isLikeThumb && findEntry.isLike == 1) {
        status = null;
      } else if (!isLikeThumb && findEntry.isLike == 0) {
        status = null;
      } else if (!isLikeThumb && findEntry.isLike == 1) {
        status = 0;
        this.openFeedbackDialog();
      } else if (isLikeThumb && findEntry.isLike == 0) {
        status = 1;
      } else if (findEntry.isLike == null) {
        if (isLikeThumb) {
          status = 1;
        } else {
          status = 0;
          this.openFeedbackDialog();
        }
      }
      let payload = {
        findEntries_id: findEntry.id,
        isLike: status,
      };

      await this.$store.dispatch("businessFindEntriesLikes/save", payload);

      this.$store.dispatch(
        "solutions/findEntries/loadAllBySolutionsIDWithLikes",
        this.data.id
      );
    },
    likeStatus(isLikeThumb, findEntry) {
      if (isLikeThumb && findEntry.isLike == 1) {
        return "mdi-thumb-up";
      } else if (!isLikeThumb && findEntry.isLike == 0) {
        return "mdi-thumb-down";
      } else if (!isLikeThumb && findEntry.isLike == 1) {
        return "mdi-thumb-down-outline";
      } else if (isLikeThumb && findEntry.isLike == 0) {
        return "mdi-thumb-up-outline";
      } else {
        if (isLikeThumb) {
          return "mdi-thumb-up-outline";
        } else {
          return "mdi-thumb-down-outline";
        }
      }
    },
    openFeedbackDialog() {
      this.feedbackDialog = true;
    },
    async init() {
      await this.$store.dispatch(
        "solutions/business/loadBySolutionsID",
        this.$route.params.id
      );
      this.$store.dispatch(
        "solutions/business/actions/loadAllBySolutionId",
        this.data.id
      );
      this.$store
        .dispatch(
          "solutions/findEntries/featuredListings/loadAllBySolutionsID",
          this.data.id
        )
        .then(() => {
          if (this.featuredListing) {
            this.$store.dispatch(
              "solutions/findEntries/featuredEntriesBenefits/loadAllByFindEntryID",
              this.featuredListing.id
            );
          }
        });
      this.$store
        .dispatch(
          "solutions/findEntries/loadAllBySolutionsIDWithLikes",
          this.data.id
        )
        .then(() => {
          if (this.data != null) {
            this.formData = JSON.parse(JSON.stringify(this.data));
            if (this.data.solutionsBusiness_id) {
              this.tabs[1].disable = false;
              this.tabs[2].disable = false;
              this.tabs[3].disable = false;
            }
          }
        });
      this.$store.dispatch("storyCard/loadAll", {
        solution_id: this.$route.params.id,
      });
    },
    viewAction(action) {
      this.$router.push(this.$route.path + "/action/" + action.id);
    },
    handleRoute() {
      if (this.$route.params.hasOwnProperty("actionsCenter_id")) {
        this.$store.dispatch(
          "actions/loadActionByActionsCenterId",
          this.$route.params.actionCenter_id
        );
        this.actionScreen = true;
      }
    },
    learnMore(link) {
      let url = link;
      if (!url.includes("https://")) {
        url = "https://" + link;
      }
      window.open(url, "_blank");
    },
    getOutcomeImage: (outcome) => getOutcomeImage(outcome),
    closeDialog() {
      this.$emit("closeDialog");
    },
    async adoptSolution() {
      let payload = {
        solutions_id: this.data.id,
      };
      let result = await this.$store.dispatch(
        "solutions/business/new",
        payload
      );
      if (result.Result == "Success") {
        this.$q.notify({
          position: "top-right",
          type: "positive",
          message: result.Response.Message,
        });
        this.init();
      } else {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an Error, Please try again later",
        });
      }
    },
    async saveSolution() {
      if (this.data.solutionsBusiness_id) {
        let payload = {
          id: this.data.solutionsBusiness_id,
          notes: this.formData.notes,
        };
        let result = await this.$store.dispatch(
          "solutions/business/save",
          payload
        );
        if (result.Result == "Success") {
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: result.Response.Message,
          });
          // this.selectedSolution = "";
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later",
          });
        }
      } else {
        let result = await this.$store.dispatch("solutions/business/new", {
          solutions_id: this.data.id,
          notes: this.formData.notes,
        });
        if (result.Result == "Success") {
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: result.Response.Message,
          });
          this.closeDialog();
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later",
          });
        }
      }
    },
    saveStoryCardFunction() {
      this.newStoryCard = false;
      this.$store.dispatch("storyCard/loadAll", {
        solution_id: this.$route.params.id,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.featuredListing__supplierName {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
}

.featuredListing__benefits {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
}

.featuredListing__about {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
}
.searchOnlineSection {
  height: 152px;
  width: 100%;
  background-color: #162c471a;
  -webkit-box-shadow: 0 6px 4px -4px black;
  -moz-box-shadow: 0 6px 4px -4px black;
  box-shadow: 0 6px 4px -4px rgb(131, 131, 131);

  .searchOnlineSection__subtitle {
    font-family: "Montserrat";
    font-style: normal;
    font-size: 12px;
    line-height: 15px;
  }
}

.searchOnlineSection__btn {
  width: 120px;
  height: 26px;
}

.searchOnlineSection__btnText {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 9px;
  line-height: 11px;
  display: flex;
  align-items: center;
  text-align: center;
}

.searchOnlineSection__title {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
}
.sendButton {
  height: 35px;

  .text {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 600;
    font-size: 10.7746px;
  }
}

.username {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 12.8766px;
}

.previewContentTitle {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
}
.previewTitle {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
}

.storyFieldLabel {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
}
.findEntryText {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
}
.findColumnHeader {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
}
.actionHeaderTitle {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
}

.actionTitle {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 11.8299px;
}
.actionHashtag {
  color: #747f8d;
}

.actionDescription {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
}

.actionTitleMain {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
}

.actionChannelLabel {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 8.87241px;
  color: #6a7480;
}
.overview {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 11.8299px;
}
.tabTitle {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
}

.headerTitle {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 16.7606px;
}

.outcomeSection {
  background-color: #f3f3f3;
  .title {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
  }
}

.buttonText {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 9px;
}
.description {
  font-weight: 400;
  font-size: 13px;
}

.subHeader {
  font-weight: 700;
  color: $accent2;
  font-size: 13px;
}

.otherSuppliersSection {
  background-color: rgba(22, 44, 71, 0.1);
}

.otherSuppliersSection_emptyText {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
}

.dislikeText {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 8px;
}

.feedbackDialogCard {
  background-color: white;
}

.feedbackDialogCard__title {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
}

.actionsCardTitle {
  font-weight: 800;
  color: $accent;
  background: #f6f6f6;
}
</style>
